import messages from './admin.json' with { type: 'json' };

export const adminFi: Readonly<typeof messages> = messages;
